<template>
  <div class="container px-8 pt-16 mx-auto lg:px-16">
    <div class="flex flex-col md:flex-row">
      <img
        class="self-center object-contain md:p-8 mb-4 md:w-1/2 md:order-1"
        src="@/assets/img/sarahJeannin.jpg"
        alt
        srcset
      />
      <div class="flex flex-col justify-center md:w-1/2 md:order-2 md:ml-8">
        <h2
          id="fonctionnement"
          class="text-3xl font-bold tracking-wider uppercase font-raleway"
        >
          Ils nous font confiance
        </h2>
        <hr class="mb-10 border border-green-500" />
        <p class="mb-10">
          Sarah Jeannin, Psychologue et docteure en Éthologie, chercheure
          associée au laboratoire d'Ethologie de l'université Paris Nanterre,
          nous accompagne avec son équipe d’experts en comportement animal sur
          la recherche et le développement du produit HerdingCats en constante
          évolution et recherche d’innovation. Ses experts nous aident notamment
          à qualifier l’activité afin de nous aider à entraîner notre
          intelligence artificielle. Sarah est également fondatrice d’<a
            class="text-green-500 focus:underline hover:underline"
            href="https://www.animal-university.fr/"
            >Animal University</a
          >
          et chercheuse reconnue dans la littérature scientifique. C’est
          d’ailleurs avec elle que nous publions nos premiers résultats destinés
          à la communauté scientifique.
        </p>
        <!-- <a href="#" v-scroll-to="'#footer'"
          class="block px-4 py-4 font-bold leading-none tracking-wider text-center text-white uppercase bg-green-500 rounded-full shadow-md hover:bg-green-400 hover:shadow-lg">
          Découvrir HerdingCats en avant-première
        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
